// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';

export const resetCustomerDetails = () => ({
    data: getCustomerDefaultState(),
    type: actions.UPDATE_CLAIM_MCC_FOLLOWUP_CUSTOMER_DETAILS
});



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-customer-followup/action-creators/reset-customer-details.js